import { GET_PUBLIC_SYSTEM_CONFIG, GET_PUBLIC_SYSTEM_SUFFIX } from "../actions/systemConfig.actions";
import { AUTH_PROVIDER_AUTH0, AUTH_PROVIDER_CAMVIO } from "src/utils/const";

/**
 * These state is not changing regardless of authentication status of the user.
 * These will be the system-wide configuration values.
 */
let initialState = {
  publicSystemConfig: {
    authProviders: [AUTH_PROVIDER_CAMVIO],
  },
  isUsingAuth0: false,
  isUsingCamvioAuth: true,
  loadTs: null,
  publicSystemSuffix: [],
  isLoadingPublicSystemSuffix: false,
};

export const systemConfigsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PUBLIC_SYSTEM_CONFIG.SUCCESS:
      const isAuth0Configured = action.payload.auth0Domain && action.payload.auth0ClientId && action.payload.auth0OrgId;

      return {
        ...state,
        publicSystemConfig: action.payload,
        isUsingAuth0: isAuth0Configured && action.payload.authProviders.includes(AUTH_PROVIDER_AUTH0),
        isUsingCamvioAuth: action.payload.authProviders.includes(AUTH_PROVIDER_CAMVIO),
        isUsingAuth0Only:
          isAuth0Configured &&
          action.payload.authProviders.includes(AUTH_PROVIDER_AUTH0) &&
          action.payload.authProviders.length === 1,
        loadTs: new Date(),
      };
      case GET_PUBLIC_SYSTEM_SUFFIX.REQUEST:
        return{
          ...state,
          isLoadingPublicSystemSuffix: true,

        };
    case GET_PUBLIC_SYSTEM_SUFFIX.SUCCESS:
      return{
        ...state,
        publicSystemSuffix: action.payload,
        isLoadingPublicSystemSuffix: false,
      };
    case GET_PUBLIC_SYSTEM_SUFFIX.FAILURE:
      return{
        ...state,
        isLoadingPublicSystemSuffix: false,
      }
    default:
      return state;
  }
};
